import api from './api'

export const landingPageService = {
  /**
   * ESSENCIAIS - Carregados primeiro (navbar, banner, cores, sections)
   */
  async getSettings() {
    try {
      const { data } = await api.get('/landing-page/settings')
      return data
    } catch (error) {
      console.error('Erro ao buscar settings:', error)
      throw error
    }
  },

  async getCustomization() {
    try {
      const { data } = await api.get('/landing-page/customization')
      return data
    } catch (error) {
      console.error('Erro ao buscar customization:', error)
      throw error
    }
  },

  async getSections() {
    try {
      const { data } = await api.get('/landing-page/sections')
      return data
    } catch (error) {
      console.error('Erro ao buscar sections:', error)
      throw error
    }
  },

  /**
   * SEÇÕES - Carregadas sob demanda (apenas as ativas)
   */
  async getSpeakers() {
    try {
      const { data } = await api.get('/landing-page/speakers')
      return data
    } catch (error) {
      console.error('Erro ao buscar speakers:', error)
      throw error
    }
  },

  async getSchedules() {
    try {
      const { data } = await api.get('/landing-page/schedules')
      return data
    } catch (error) {
      console.error('Erro ao buscar schedules:', error)
      throw error
    }
  },

  async getSponsors() {
    try {
      const { data } = await api.get('/landing-page/sponsors')
      return data
    } catch (error) {
      console.error('Erro ao buscar sponsors:', error)
      throw error
    }
  },

  async getTestimonials() {
    try {
      const { data } = await api.get('/landing-page/testimonials')
      return data
    } catch (error) {
      console.error('Erro ao buscar testimonials:', error)
      throw error
    }
  },

  async getFaqs() {
    try {
      const { data } = await api.get('/landing-page/faqs')
      return data
    } catch (error) {
      console.error('Erro ao buscar faqs:', error)
      throw error
    }
  },

  async getPhotos() {
    try {
      const { data } = await api.get('/landing-page/photos')
      return data
    } catch (error) {
      console.error('Erro ao buscar photos:', error)
      throw error
    }
  },

  async getVideos() {
    try {
      const { data } = await api.get('/landing-page/videos')
      return data
    } catch (error) {
      console.error('Erro ao buscar videos:', error)
      throw error
    }
  },

  /**
   * FALLBACK - Endpoint único (para compatibilidade)
   * Use apenas se não quiser refatorar tudo
   */
  async getAll() {
    try {
      const { data } = await api.get('/landing-page')
      return data
    } catch (error) {
      console.error('Erro ao buscar landing page:', error)
      throw error
    }
  }
}